import styled from 'styled-components';

export const ShippingStatusUploadContainerStyled = styled.div`
  width: 100%;
  max-width: 900px;
  max-height: 85vh;
  overflow: auto;
  padding: 1.5rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  border-radius: 8px;
  .modal_title {
    font-size: 18px;
    margin-bottom: 14px;
  }
  .step_bar {
    display: flex;
    gap: 8px;
    margin-bottom: 18px;
    .step_item {
      flex: 1;
      padding: 8px 10px;
      border-radius: 6px;
      font-size: 13px;
      text-align: center;
      background: #f2f4f7;
      color: #98a2b3;
      &.active {
        background: ${({ theme }) => theme.COLORS.BLUE_2 || '#2f6fed'};
        color: #fff;
      }
      &.done {
        background: #e6f4ea;
        color: #1e7a3c;
      }
    }
  }
  .help_block {
    background: #f7f9fc;
    border-radius: 6px;
    padding: 14px 16px;
    margin-bottom: 16px;
    font-size: 13px;
    line-height: 1.7;
    .help_title {
      font-size: 14px;
      margin-bottom: 6px;
    }
    ol {
      margin: 0;
      padding-left: 18px;
    }
    .help_note {
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px solid #e4e9f0;
      color: #667085;
    }
  }
  .upload_row {
    margin-bottom: 18px;
  }
  .summary_row {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    .summary_item {
      flex: 1;
      padding: 12px;
      border-radius: 6px;
      background: #f7f9fc;
      text-align: center;
      .summary_num {
        font-size: 22px;
      }
      .summary_label {
        font-size: 12px;
        color: #667085;
      }
      &.is_error {
        background: #fdecec;
        .summary_num {
          color: #9c2b2b;
        }
      }
    }
  }
  .section_title {
    font-size: 14px;
    margin-bottom: 10px;
    &.error {
      color: #9c2b2b;
    }
    &.success {
      color: #1e7a3c;
    }
  }
  .table_wrap {
    max-height: 320px;
    overflow: auto;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    margin-bottom: 16px;
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 13px;
      th,
      td {
        padding: 8px 10px;
        text-align: left;
        border-bottom: 1px solid #f0f0f0;
        vertical-align: top;
      }
      th {
        background: #f7f9fc;
        position: sticky;
        top: 0;
        font-weight: normal;
        color: #667085;
      }
      .w60 {
        width: 60px;
      }
      .highlight {
        color: #1e7a3c;
      }
    }
  }
  .retry_note {
    font-size: 13px;
    color: #667085;
    margin-bottom: 16px;
  }
  .action_row {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    .btn_item {
      width: 130px;
      &.wide {
        width: 190px;
      }
    }
  }
`;
